import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-print",
  "use": "icon-si-glyph-print-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-print\" id=\"icon-si-glyph-print\"><title>1066</title><defs></defs><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g transform=\"translate(1.000000, 1.000000)\" fill=\"#434343\"><path d=\"M5,11 L4.99999993,14.9798584 L10.9933471,14.9798584 L10.9933472,11 L5,11 Z\" class=\"si-glyph-fill\" /><rect x=\"4\" y=\"0\" width=\"7.948\" height=\"2.96\" class=\"si-glyph-fill\" /><path d=\"M0.041,4.016 L0.041,13.016 L3.95141967,13.016 L3.95141967,10.0096256 L12,10.0096256 L12,13.016 L16.041,13.016 L16.041,4.016 L0.041,4.016 L0.041,4.016 Z M3.01600005,6.02929693 L1.96900005,6.02929693 L1.969,4.953 L3.016,4.953 L3.01600005,6.02929693 Z M5.016,5.969 L3.969,5.969 L3.969,4.969 L5.016,4.969 L5.016,5.969 L5.016,5.969 Z\" class=\"si-glyph-fill\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-print.svg
// module id = 1XKp
// module chunks = 62